import { z } from "zod";
import { addressSchema } from "./Address";
import { isValidPhoneNumber } from "./Utils"

export const companySchema = z.object({
    name: z.string().max(50),
    street1: z.string().max(30),
    street2: z.string().max(30).nullish().optional(),
    street3: z.string().max(30).nullish().optional(),
    countryCode: z.string().max(2),
    zipCode: z.string().max(10),
    city: z.string().max(30),
    contactName: z.string().max(50),
    contactPhone: z.string().max(20).refine(isValidPhoneNumber, {message: "Invalid format"}).optional(),
    contactEmail: z.string().email().nullish(),
    
    financeContactName: z.string().max(50).nullish().optional(),
    financeContactPhone: z.string().max(20).refine(isValidPhoneNumber, {message: "Invalid format"}).optional().nullish().optional(),
    financeContactEmail: z.string().email().nullish(),
    
    emailInvoiceTo: z.string().email().nullish(),
    orgNo: z.string().max(20),
    vatNo: z.string().max(20),

    paymentPlanId: z.string().nullish(),
    nmbExtraUsers: z.number().int().nullish(),
    nmbExtraTrp: z.number().int().nullish(),
    saveExtraDays: z.number().int().nullish(),

    usersCount: z.number().int().nullish(),
    activeCarriers: z.array(z.string()),
    autoAdjustPlan: z.boolean(),

    warehouse: addressSchema.extend({
        openingTime: z.string().refine(val => (/^\d{2}:\d{2}(?::\d{2}){0,1}$/g).test(val), {message: "Invalid format. Must be HH:mm"}).optional(),
        closingTime: z.string().refine(val => (/^\d{2}:\d{2}(?::\d{2}){0,1}$/g).test(val), {message: "Invalid format. Must be HH:mm"}).optional(),
        sameAsBillingAddress: z.boolean(),
        currency: z.string(),
        tradingAccounts: z.array(z.object({
            type: z.string(),
            number: z.string()
        }))
    }),

    invoices: z.array(z.object({
        invoiceNo: z.string(),
        invoiceDate: z.string(),
        dueDate: z.string(),
        invoiceType: z.string(),
        invoiceStatus: z.number().int(),
        invoiceTotalInclVAT: z.number(),
        currencyCode: z.string(),
        sentTo: z.string(),
        hasFile: z.boolean(),
    })).nullish()
});

export type CompanyType = z.infer<typeof companySchema>;